"use client";

import Link from "next/link";
import React, { type HTMLAttributes, type ReactElement } from "react";

interface StatProps extends HTMLAttributes<HTMLDivElement> {
  number: number;
  label: string;
  link?: string;
  icon?: ReactElement;
}

function Stat({
  number,
  label,
  link = undefined,
  icon = undefined,
  ...props
}: Readonly<StatProps>): ReactElement {
  if (link) {
    return (
      <div className="flex-1" {...props}>
        <Link
          className="flex-1 flex flex-col justify-center gap-1 p-10"
          href={link}
        >
          {icon}
          <span className="text-8xl sm:text-4xl lg:text-6xl font-thin">
            {number}
          </span>
          <span>{label}</span>
        </Link>
      </div>
    );
  }

  return (
    <div className="flex-1" {...props}>
      {icon}
      <span className="text-8xl sm:text-4xl lg:text-6xl font-thin">
        {number}
      </span>
      <span>{label}</span>
    </div>
  );
}

export { Stat, type StatProps };
